import { HttpErrorResponse } from '@angular/common/http';
import { Deserializable } from '../deserializable';

export class UserAitSearchResponse implements Deserializable {
  public userId: number;
  public fullName: string;
  public balance: number;
  public manuallyAddedBalance: number;
  public balanceDate: Date;
  public accountNumber: number;
  public isUpdating: boolean = false;
  public recentlyUpdated: boolean = false;
  public updateSuccess: boolean = false;
  public isGeneratingAITHistoryDoc: boolean = false;
  public isGeneratingLastApprovedPinDoc: boolean = false;
  public error: HttpErrorResponse;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
